import $ from 'jquery';
import Filter from './Filter';

// The search filter
export default class SliderFilter extends Filter {

  constructor($element, options) {
    super($element, options);
    if ($element.length === 0) return false;

    console.log($element);

    this.filterType = "SliderFilter";
    this.emptyValue = "0-40";

    if($element.length <= 0) return false;

    this.control = $element.find('input').slider({
      handle: 'round',
      formatter: function(values) {
        let fm = $element.find('input').data('formatter');

        $element.find('.min').html(values[0]);
        $element.find('.max').html(values[1]);
        return fm.replace('{a}', values[0]).replace('{b}', values[1]);
      }
    });

    this.control.on('slideStop', this.onSlideStop.bind(this));
  }

  getValue() {
    if(this.$element.length <= 0) return false;

    let values = this.control.data('sliderValue').join('-');

    return (!values || values == this.emptyValue) ? false : values;
  }

  setValue( values ) {
    if( !values ) values = this.emptyValue;
    if( typeof values == "string") {
      values = values.split("-");
    }

    this.control.slider('setValue', [parseInt(values[0]), parseInt(values[1])]);
  }

  getKey() {
    return this.getElement().data('key') || this.getElement().data('wjp-filter-key');
  }

  onSlideStop(ev) {
    $.messages.send({
      type: 'FILTER/VALUE_CHANGED',
      key: this.getKey(),
      value: this.getValue(),
      sender: this
    });
  }

}



/** WEBPACK FOOTER **
 ** ../assets/js/filters/SliderFilter.js
 **/